












import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import SubmitPreview from "./SubmitPreview.vue";
import SubmitConfig from "./SubmitConfig.vue";
import { mixins } from "vue-class-component";

import commonMixin from "@/mixins/commonNewMixins";
import { decorationData, questionData, testData, QuestionDataType } from "../../../../config/newQuestionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
@Component({
  name: "questionnaireSubmitSet",
  components: {
    SubmitPreview,
    SubmitConfig,
  },
  filters: {},
})
export default class questionnaireSubmitSet extends mixins(commonMixin) {
  @Prop({
    type: String,
    default: "ACTIVITY",
  })
  type?: string;
  private get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }
  async CHECK_DATA_validate() {
    try {
      let result = await this.getModulesConfigInstance().validate();

      // if (result.valid) {
      //   let totalScore = 0;
      //   this.dataList.forEach((element: any) => {
      //     totalScore += Number(element.data.itemScore) || 0;
      //   });
      //   QuestionnaireEditModule.SET_TOTALSCORE_DATA(totalScore as number);
      // }

      return result;
    } catch (error) {
      console.log("CHECK_DATA_validateerror", error);
      return false;
    }
  }
  //////////////////////
}
